import { buildWebITData } from "@/data/buildWebIT.data";
import { contactData } from "@/data/contact-info.data";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const LinkedInIcon = () => {
  return (
    <Link
      href={buildWebITData.linkedinLink}
      area-label="LinkedIn"
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* <FaLinkedin
                    size={24}
                    className="text-white hover:underline transition-colors duration-300"
                  /> */}
      <Image
        src={contactData[1].src}
        alt="LinkedIn Icon"
        width={28}
        height={28}
      />
    </Link>
  );
};

export default LinkedInIcon;
